<template>
    <div class="audio-uploader-container">
        <p class="title">Music Samples</p>
        <div v-if="audios.length" class="audio-samples">
            <MusicPlayer
                :styles="musicPlayerStyles"
                :songs.sync="audios"
                @sync-title-change="updateAudioTitle"
                @sync-song-delete="deleteAudio"
            />
        </div>
        <input
            ref="audioUploadEl"
            type="file"
            @change="uploadAudio"
            accept="audio/mp3, audio/wav"
            hidden="hidden"
        />
        <button @click="handleUploadAudio" class="add-audio-btn">Upload music sample</button>
    </div>
</template>
<script>
    import MusicPlayer from '@/components/ui/music-player/MusicPlayer.vue'
    import { useAudioUploader } from '@/composables/ui/useAudioUploader'
    export default {
        name: 'AudioUploader',
        components: {
            MusicPlayer
        },
        setup() {
            const {
                musicPlayerStyles,
                audioUploadEl,
                audios,
                uploadAudio,
                handleUploadAudio,
                updateAudioTitle,
                deleteAudio
            } = useAudioUploader()
            return {
                musicPlayerStyles,
                audioUploadEl,
                audios,
                uploadAudio,
                handleUploadAudio,
                updateAudioTitle,
                deleteAudio
            }
        }
    }
</script>
<style lang="scss" scoped>
    .audio-uploader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #8b8b8b;
            font-family: Instrument Sans;
            font-size: 12px;
            font-style: normal;
            font-weight: 650;
            line-height: 135%;
            letter-spacing: 0.12px;
            align-self: flex-start;
        }
        .audio-samples {
            width: 100%;
        }
        .add-audio-btn {
            color: #8b8b8b;
            font-family: Instrument Sans;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 130%;
            letter-spacing: 0.14px;
            text-decoration-line: underline;
            background: none;
            align-self: flex-start;
            padding-left: 0px;
        }
    }
</style>
